import type { WebshopEntryFormButton } from "./types/types";

export const createWebshopEntryFormButton = (): WebshopEntryFormButton => {
  const event: WebshopEntryFormButton = {
    event: "Webshop Entry Form Button",
  };
  return event;
};
